// Web-compatible AsyncStorage implementation using localStorage
const AsyncStorage = {
  getItem(key) {
    return new Promise((resolve) => {
      try {
        resolve(localStorage.getItem(key));
      } catch (error) {
        resolve(null);
      }
    });
  },

  setItem(key, value) {
    return new Promise((resolve) => {
      try {
        localStorage.setItem(key, value);
        resolve();
      } catch (error) {
        resolve();
      }
    });
  },

  removeItem(key) {
    return new Promise((resolve) => {
      try {
        localStorage.removeItem(key);
        resolve();
      } catch (error) {
        resolve();
      }
    });
  },

  clear() {
    return new Promise((resolve) => {
      try {
        localStorage.clear();
        resolve();
      } catch (error) {
        resolve();
      }
    });
  },

  getAllKeys() {
    return new Promise((resolve) => {
      try {
        resolve(Object.keys(localStorage));
      } catch (error) {
        resolve([]);
      }
    });
  },

  multiGet(keys) {
    return new Promise((resolve) => {
      try {
        const result = [];
        for (const key of keys) {
          result.push([key, localStorage.getItem(key)]);
        }
        resolve(result);
      } catch (error) {
        resolve([]);
      }
    });
  },

  multiSet(keyValuePairs) {
    return new Promise((resolve) => {
      try {
        for (const [key, value] of keyValuePairs) {
          localStorage.setItem(key, value);
        }
        resolve();
      } catch (error) {
        resolve();
      }
    });
  },

  multiRemove(keys) {
    return new Promise((resolve) => {
      try {
        for (const key of keys) {
          localStorage.removeItem(key);
        }
        resolve();
      } catch (error) {
        resolve();
      }
    });
  }
};

export default AsyncStorage;